import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { List } from 'office-ui-fabric-react/lib/List';
import { Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import styles from './BundleActivity.style';
import { can } from '../../utils/auth';
import BundleActivityDetails from '../BundleActivityDetails';

const operationMessages = {
  edited: 'revised',
};

const BundleAction = item => {
  const { operation, initiatedBy } = item.action;
  const operationType =
    operation && Object.keys(operationMessages).find(o => operation.includes(o));
  const actionMessage = operationMessages[operationType] || `${operation}`;
  let activityMessage;
  if (operation === 'edited') {
    activityMessage = 'Bundle Definition';
  } else {
    activityMessage = 'Product Bundle';
  }
  const initiatedName = can('viewActivityInitiatedBy')
    ? initiatedBy?.name || initiatedBy
    : 'Microsoft';

  return (
    <>
      <Text as="h4" className={styles.itemName}>
        {initiatedName} <span className={styles.actionMessage}>{actionMessage}</span>{' '}
        {activityMessage}
      </Text>
    </>
  );
};

const ActivityItem = item => {
  const dateObj = item.timestamp && new Date(item.timestamp);
  return (
    <div className={styles.activityItem}>
      <Persona
        imageUrl={can('viewActivityInitiatedBy') ? '' : '/images/msft-avatar.png'}
        size={PersonaSize.size28}
        className={styles.personaCoin}
        hidePersonaDetails
      />
      <div className={styles.itemContent}>
        <BundleAction action={item} />
        <BundleActivityDetails item={item} className={styles.details} />
      </div>
      <Text as="p" variant="small" className={styles.date}>
        {item.timestamp &&
          `${dateObj.toLocaleString('en-us', {
            month: 'long',
          })} ${dateObj.getDate()}, ${dateObj.getFullYear()}`}
      </Text>
    </div>
  );
};

const BundleActivity = ({ items }) => (
  <FocusZone direction={FocusZoneDirection.vertical}>
    <List items={items} onRenderCell={ActivityItem} />
  </FocusZone>
);

BundleActivity.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      initiatedBy: PropTypes.shape({
        name: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
      }),
      timestamp: PropTypes.string,
    }),
  ),
};

BundleActivity.defaultProps = {
  items: [],
};

export default BundleActivity;
